import React, { ReactElement, useEffect } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import { InputNumberProps } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import ExtendedLabel from "../../extendedLabel/extendedLabel";

interface InputNumProps extends InputNumberProps {
  label: string;
  name: string;
  isFloat: boolean;
  allowNegatives: boolean;
  value: any;
  warn: string;
  isRequired?: boolean;
  extendedlabel?: string | ReactElement;
}
export default function InputNumberComponent(props: InputNumProps) {
  const { name, label, warn, extendedlabel, isFloat = false, allowNegatives = false, isRequired, ...rest } = props;
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [displayValue, setDisplayValue] = React.useState<any>("");

  useEffect(() => {
    if (rest.value != null && Number.parseFloat(rest.value) != Number.parseFloat(displayValue)) {
      setDisplayValue(rest.value.toString());
    }
  }, [rest.value]);

  async function handleBlur() {
    await setFieldTouched(name, true);
  }
  return (
    <div className="flex flex-col w-full py-2" id={name.split(".").pop()}>
      <div className="extentedlabel-container">
        {" "}
        {!props?.hidden && label && (
          <label htmlFor={name} className={isRequired ? "isRequired" : ""} id={name.split(".").pop()}>
            {" "}
            {label}
          </label>
        )}{" "}
        {extendedlabel && <ExtendedLabel text={extendedlabel} />}
      </div>
      <InputText
        alt={name}
        name={name}
        {...rest}
        onChange={(e: any) => {
          const negativePrefix = allowNegatives ? "-{0,1}" : "";
          const regExpString = isFloat ? `^$|^${negativePrefix}(?:\\d+\\.?\\d*|\\.\\d+)$` : `^$|^${negativePrefix}\\d+$`;
          const regExp = new RegExp(regExpString);
          const val = e.target.value;
          if (val != "" && regExp.test(val)) {
            setDisplayValue(val);
            const parsed = Number.parseFloat(val);
            setFieldValue(name, parsed);
          } else if (val === "" || (val === "-" && allowNegatives) || (val === "." && isFloat)) {
            setDisplayValue(val);
            setFieldValue(name, null);
          } else {
            setDisplayValue(displayValue);
          }
        }}
        onBlur={handleBlur}
        value={displayValue}
      />
      {warn && <div className=" text-left fieldadv">{warn}</div>}
      <ErrorMessage name={name ?? ""} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
